import PropTypes from 'prop-types';

import { Box, Button, Grid, Typography } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import FormFieldComponent from '../../Forms/FormFieldComponent';

import { formatSelect, lengthValidation250, required } from '../../Forms/utils';
import { formatResidents } from '../utils';

import {
  BUTTON_SELECT_COMPONENT,
  CHECKBOX,
  REACT_SELECT_INPUT,
  STYLED_TEXT,
} from '../../Forms/fieldTypes';

const FrontDeskPackagesForm = (props) => {
  const { t } = useTransl();
  const {
    onSubmit,
    formError,
    isLoading,
    isSkeletonDisabled,
    deliveryTypeOptions,
    recipients,
    units,
    formValues,
  } = props;

  return (
    <Box p="2rem 2.5rem">
      <form onSubmit={onSubmit} method="post" autoComplete="off">
        {formError && (
          <Typography color="secondary" variant="caption">
            {formError}
          </Typography>
        )}
        <FormFieldComponent
          fieldType={BUTTON_SELECT_COMPONENT}
          keyName="type"
          isLoading={isLoading}
          isSkeletonDisabled={isSkeletonDisabled}
          options={deliveryTypeOptions}
          validate={[required]}
        />
        <Grid
          container
          display="flex"
          columnSpacing="1rem"
          rowSpacing={0}
          justifyContent="space-between"
        >
          <Grid item xs={12}>
            <FormFieldComponent
              fieldType={REACT_SELECT_INPUT}
              keyName="recipients"
              label={t('title.recipient_s')}
              isLoading={isLoading}
              isSkeletonDisabled={isSkeletonDisabled}
              options={formatResidents(recipients)}
              disabled={Boolean(formValues?.units?.length)}
              multi
            />
          </Grid>
          <Grid item xs={12}>
            <FormFieldComponent
              fieldType={REACT_SELECT_INPUT}
              keyName="units"
              label={t('delivery.units')}
              isLoading={isLoading}
              isSkeletonDisabled={isSkeletonDisabled}
              options={formatSelect(units)}
              sortAlphabetically={false}
              disabled={Boolean(formValues?.recipients?.length)}
              multi
            />
          </Grid>
          <Grid item xs={12}>
            <FormFieldComponent
              fieldType={STYLED_TEXT}
              keyName="comments"
              label={t('title.comments')}
              isLoading={isLoading}
              isSkeletonDisabled={isSkeletonDisabled}
              validate={[lengthValidation250]}
              multiline
            />
          </Grid>
        </Grid>
        <Grid container display="flex" columnSpacing="1rem" rowSpacing={0}>
          <Grid item xs={12}>
            <FormFieldComponent
              fieldType={CHECKBOX}
              keyName="pickUp"
              label={t('title.pickUpOutgoing')}
              isLoading={isLoading}
              isSkeletonDisabled={isSkeletonDisabled}
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disableElevation
              disabled={isLoading}
              sx={{ margin: '0 0 0 auto' }}
            >
              {t('packages.addAndNotifyResident')}
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

FrontDeskPackagesForm.defaultProps = {
  formError: null,
  formValues: {},
};

FrontDeskPackagesForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isSkeletonDisabled: PropTypes.bool.isRequired,
  deliveryTypeOptions: PropTypes.instanceOf(Array).isRequired,
  recipients: PropTypes.instanceOf(Array).isRequired,
  units: PropTypes.instanceOf(Array).isRequired,
  formValues: PropTypes.instanceOf(Object),
  formError: PropTypes.string,
};

export default FrontDeskPackagesForm;
